import type { ReactElement } from 'react';
import { EmptyState } from '../../ui';

/**
 * A filter that leaves nothing (APP-149 D4): the table's one empty row says so and offers the way
 * back, never a bare "No data". The list itself isn't empty, so it's neither day one nor caught up.
 */
export function NoMatches({
  onClear,
  what = 'awards',
}: {
  onClear: () => void;
  /** What the table lists: "awards", "people", "grants". */
  what?: string;
}): ReactElement {
  return (
    <EmptyState
      variant="first-day"
      art="search"
      size="sm"
      headline={`No ${what} match these filters`}
      body="Change a filter above, or clear them all to see the whole list again."
      action={{ label: 'Clear filters', onPress: onClear }}
    />
  );
}
